<template>
  <div>
    <v-dialog
      width="550px"
      title="Edit Preference"
      :visible.sync="dialogVisible"
      :scrollbar="false"
      @open="onOpen"
      @closed="onClosed"
    >
      <el-form ref="form" :model="form" :rules="formRules" label-width="250px" label-position="left">
        <el-form-item prop="DiseaseState" label="Disease State Presentation">
          <el-select
            v-model="form.DiseaseState"
            placeholder="Please Choose"
            clearable
            filterable
            style="width: 200px"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="NilexDisease" label="NILEX Disease State Presentation">
          <el-select
              v-model="form.NilexDisease"
              placeholder="Please Choose"
              clearable
              filterable
              style="width: 200px"
          >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="ProductOverview" label="Product Overview Presentation">
          <el-select
              v-model="form.ProductOverview"
              placeholder="Please Choose"
              clearable
              filterable
              style="width: 200px"
          >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="MedicalEducation" label="Medical Education Inform">
          <el-select
              v-model="form.MedicalEducation"
              placeholder="Please Choose"
              clearable
              filterable
              style="width: 200px"
          >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          prop="InformActivity"
          label="Inform Activity (Label/Guideline Inform)"
        >
          <el-select
              v-model="form.InformActivity"
              placeholder="Please Choose"
              clearable
              filterable
              style="width: 200px"
          >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item prop="SafetyData" label="Safety Data Dissemination">
          <el-select
              v-model="form.SafetyData"
              placeholder="Please Choose"
              clearable
              filterable
              style="width: 200px"
          >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="actions">
        <el-button @click="onClosed">Cancel</el-button>
        <el-button type="primary" @click="onConfirm" :loading="loading">
          {{ loading ? "Saving" : "Save" }}
        </el-button>
      </div>
    </v-dialog>
  </div>
</template>

<script>
// import { trimValidate } from "../../../utils/validator";
export default {
  name: "NewSRMenuDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {
        seId: null,
        DiseaseState: null,
        NilexDisease: null,
        ProductOverview: null,
        MedicalEducation: null,
        InformActivity: null,
        SafetyData: null,
      },
      formRules: {},
      mlList: [],
      loading: false,
      options: [
        {
          label: 'By Call',
          value: 'By Call'
        },
        {
          label: 'By Meeting',
          value: 'By Meeting'
        },
        {
          label: 'By Email',
          value: 'By Email'
        },
        {
          label: 'Uninterested',
          value: 'Uninterested'
        }
      ]
    };
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onOpen() {
      if (this.data) {
        this.$nextTick(() => {
          Object.assign(this.form, {
            seId: this.data.SEID,
            DiseaseState: this.data.DiseaseState,
            NilexDisease: this.data.NilexDisease,
            ProductOverview: this.data.ProductOverview,
            MedicalEducation: this.data.MedicalEducation,
            InformActivity: this.data.InformActivity,
            SafetyData: this.data.SafetyData
          });
        });
      }
    },
    onClosed() {
      this.$refs.form.resetFields();
      this.$emit("update:visible", false);
      this.$emit("update:data", null);
    },
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.axios
            .post("/seDetail/updatePreference", {
              SEID: this.form.seId,
              DiseaseState: this.form.DiseaseState,
              NilexDisease: this.form.NilexDisease,
              ProductOverview: this.form.ProductOverview,
              MedicalEducation: this.form.MedicalEducation,
              InformActivity: this.form.InformActivity,
              SafetyData: this.form.SafetyData
            })
            .then(({ code, msg }) => {
              if (code === 200) {
                this.onClosed();
                this.$emit("success");
                this.$message.success("Update Preference successfully");
              } else {
                this.$message.error(msg);
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form {
  .el-form-item {
    margin-bottom: 10px;
  }

  ::v-deep {
    .el-form-item__label {
      padding: 0 !important;
    }
  }

  .el-input,
  .el-select {
    width: 100%;
  }
}

.actions {
  margin-top: 20px;
  text-align: right;
}

::v-deep {
  .el-dialog__header {
    padding-bottom: 0;
  }

  .el-dialog__body {
    padding: 20px 40px 20px;
  }

  .el-dialog__footer {
    padding: 0;
  }
}
</style>
